import { DataTableColumnProps } from './DataTable.types';

/**
 * DataTableColumn is a phantom component — it never renders anything.
 * It exists solely as a declarative API for defining columns within DataTable.
 *
 * Usage:
 * <DataTable ...>
 *   <DataTableColumn id="col-1" field="name" title="Nome" width="200px" canSort>
 *     {(row) => <span className="font-bold">{row.name}</span>}
 *   </DataTableColumn>
 *   <DataTableColumn id="col-2" field="city" title="Cidade" width="150px" canSort />
 * </DataTable>
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function DataTableColumn<T>(_props: DataTableColumnProps<T>): null {
    return null;
}
